import { createSelector } from "reselect";

import { featureId } from "./utils";

import { RootState } from "../reducers";
import { FeatureDcExtended } from "./types";

const getSelectFeatures = ({ selectFeatures }: RootState) => selectFeatures;

export const getCurrentFeatureId = createSelector(getSelectFeatures, (selectFeatures): string => {
  return (selectFeatures && selectFeatures.currentId) || null;
});

export const getSelectedFeatures = createSelector(
  getSelectFeatures,
  (selectFeatures): Record<string, FeatureDcExtended[]> => selectFeatures.features ?? {},
);

export const getSelectedFeaturesTotalCounts = createSelector(
  getSelectFeatures,
  (selectFeatures): Record<string, number> => selectFeatures.totalCounts ?? {},
);

export const getSelectFeaturesInitialized = createSelector(getSelectFeatures, state => state.initialized);

export const getSelectFeaturesLayerName = createSelector(getSelectFeatures, state => state.layerName);

export const getSelectFeaturesStatisticsActive = createSelector(getSelectFeatures, state => state.statisticsActive);

export const getCurrentFeatureIndex = createSelector(
  getSelectedFeatures,
  getCurrentFeatureId,
  getSelectFeaturesLayerName,
  (features, currentFeatureId, layerName) =>
    featureId && features[layerName]?.length
      ? features[layerName]?.findIndex(feature => featureId(feature) === currentFeatureId)
      : -1,
);

export const getSelectedFeaturesCount = createSelector(
  getSelectedFeatures,
  getSelectFeaturesLayerName,
  (features, layerName) => features[layerName]?.length,
);

export const getCurrentFeature = createSelector(
  getSelectedFeatures,
  getSelectFeaturesLayerName,
  getCurrentFeatureId,
  (features, layerName, currentId) => features?.[layerName]?.find(item => item.id === currentId),
);

export const getSelectFeaturesGeometryMasking = createSelector(
  getSelectFeatures,
  selectFeatures => selectFeatures.geometryMasking,
);
